/**
 * Format a calendar date (YYYY-MM-DD or ISO timestamp) without timezone shift.
 * `new Date('2026-01-01')` is UTC midnight, which displays as Dec 31 in US timezones.
 */
export function formatCalendarDate(dateValue, options = {}) {
  if (!dateValue) return '';
  const raw = String(dateValue);
  const datePart = raw.includes('T') ? raw.slice(0, 10) : raw.slice(0, 10);
  const [year, month, day] = datePart.split('-').map((part) => parseInt(part, 10));
  if (!year || !month || !day) return '';
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    ...options,
  });
}
